
import { AxiosResponse } from 'axios';

// import { _axios } from '../mock/axiosMock';
import { _axios } from '../common/customAxios';
import { ApiErrorData, getErrorMessage, getErrorResult } from '../common/errorMessageUtil';
import {ERROR_CODE_TO_MESSAGE_MAPPED, DEFAULT_ERROR_MESSAGE} from '../common/errorCode';

// 설문조사 여부 조회
export function callGetSurveyFlag(data: RequestGetSurveyFlagData):Promise<AxiosResponse<ResponseGetSurveyFlagData>>{
  return _axios({
    method: 'get',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/cbt/survey/flag',
    params: {
      ...data
    }
  });
}

// 게임 플레이 정보 조회
export function callGetPlayer(data: RequestGetPlayerData):Promise<AxiosResponse<ResponseGetPlayerData>>{
  return _axios({
    method: 'get',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/cbt/player',
    params: {
     ...data
    }
  });
}

// 쿠폰 발급
export function callPostCoupon(data: RequestPostCouponData):Promise<AxiosResponse<ResponsePostCouponData>>{
  return _axios({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/cbt/coupon',
    data
  });
}


// Survey 신청
export function callPostSurvey(data: RequestPostSurveyData):Promise<AxiosResponse<ResponsePostSurveyData>>{
  return _axios({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/cbt/survey',
    data
  });
}


/*

export const callTest = (data: any):Promise<AxiosResponse< any >> => {
  return _axios({
    method: 'get',
    headers: {
      'content-type': 'application/json',
    },
    responseType: 'json',
    url: '/ingame/api/recovery/history/recoveryDetail',
    params: {
      data
    }
  });
};

async function test(){
  try{
    const result = await _axios.get('/test/test');

  }catch(error){
    if (_axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});
    }
  }
}


*/
